import { createSlice } from "@reduxjs/toolkit";
import { map } from "lodash";
import { string } from "prop-types";

const initialOrdersState = {
  entities: [],
  supplier: null,
  products: [],
  subTotal: 0,
  subTotalAfterDiscount: 0,
  warehouseOne: null,
  no: null,
  id: null,
  from_stock_status: null,
  warehouseTwo: null,
  to_stock_status: null,
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  productCartStatus: null,
  Added: null,
  remove: null,
  completed: false,
  warehouseOption: undefined,
  warehouseData: undefined,
  deliveryDate: null,
  message: {
    error: null,
    success: null,
    cartError: null,
    cartSuccess: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const stockTransferSlice = createSlice({
  name: "stockTransfers",
  initialState: initialOrdersState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findProducts
    productsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.products.map((product) => {
        state.entities = state.entities.filter((entity) => entity.id != product.id);
      });
    },
    //remove product added to an order
    removeSelectedProduct: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { id } = action.payload;
      state.entities = state.entities.filter((product) => product.id != id);
    },

    // set Values in the form for stock transfer edit
    setStockTransferForm: (state, action) => {
      const { id, no, delivery_date, channel_from, channel_to, stock_transfer_details, to_stock_status, from_stock_status } = action.payload.entity;
      const { productEntities } = action.payload;
      state.no = no;
      state.id = id;
      state.deliveryDate = delivery_date;
      state.from_stock_status = from_stock_status;
      state.warehouseOne = channel_from;
      state.to_stock_status = to_stock_status;
      state.warehouseTwo = channel_to;

      state.products = stock_transfer_details.map((stock, key) => {
        return {
          ...stock.product,
          quantity: stock.qty,
          unit: stock.unit,
          unit_prices: productEntities[key].unit_prices,
          selected_unit_price: productEntities[key].selected_unit_price,
        };
      });

      state.actionsLoading = false;
    },

    // createStockTransfer
    stockTransferCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.entities = [];
      state.message.success = message;
      state.actionsLoading = false;
      state.listLoading = false;
    },

    // updateStockTransfer
    stockTransferUpdated: (state, action) => {
      const { message, entity } = action.payload;
      state.message.success = message;
      state.actionsLoading = false;
      state.listLoading = false;
    },

    addProduct: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.products.push({ ...action.payload.product, unit: action.payload.product.sold_by_unit });
      state.message.success = "Product added to cart";
      state.added = true;
    },

    //update product quantity
    updateQuantity: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { product, quantity } = action.payload;
      state.products = state.products.map((entity) => {
        if (product.id === entity.id) {
          entity.quantity = quantity;
          entity.subTotal = entity.quantity * entity.priceAfterDiscount;
        }
        return entity;
      });
    },

    // update sold by unit
    updateSoldByUnit: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { product, value } = action.payload;
      state.products = state.products.map((entity) => {
        if (product.id === entity.id) {
          entity.unit = value;
        }
        return entity;
      });
    },

    //change product price
    changePrice: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { product, price } = action.payload;
      state.products = state.products.map((entity) => {
        if (product.id === entity.id) {
          entity.newPrice = price;
          entity.priceAfterDiscount = price;
          entity.discount = 0.0;
          entity.discountType = true;
          entity.subTotal = entity.quantity * entity.priceAfterDiscount;
        }
        return entity;
      });
    },

    //remove product from cart
    removeProduct: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { product } = action.payload;
      state.products = state.products.filter((pros) => pros.id != product.id);
      state.entities.push(product);
      state.message.cartSuccess = "Product removed from cart";
      state.productCartStatus = null;
    },

    // updateOrder
    updateSubTotal: (state, action) => {
      state.error = null;
      state.subTotalAfterDiscount = action.payload.totalAfterDiscount;
      state.subTotal = action.payload.total;
    },

    //error state and msg update
    updateProductCartStatus: (state, action) => {
      const { message } = action.payload;
      state.productCartStatus = null;
      state.added = true;
    },

    //change complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
        case "cartSuccess":
          state.message.cartSuccess = message;
          break;
        case "cartError":
          state.message.cartError = message;
          break;
      }
    },
    resetStates: (state, action) => {
      state.no = null;
      state.entities = [];
      state.products = [];
      state.deliveryDate = null;
      state.subTotal = 0;
      state.totalCount = 0;
      state.error = null;
      state.message.error = null;
      state.warehouseOne = null;
      state.warehouseTwo = null;
    },
    // empty cart
    emptyCart: (state, action) => {
      state.entities = [];
      state.products = [];
      state.warehouseData = null;
      state.warehouseOption = null;
      state.deliveryDate = null;
      state.listLoading = false;
      state.totalCount = 0;
      state.actionsLoading = false;
      state.error = null;
      state.message.error = null;
      state.message.success = "Cart emptied!";
    },
    setWarehouses: (state, action) => {
      if (action.payload.warehouseNo == 1) {
        state.warehouseOne = action.payload.warehouse;
      } else if (action.payload.warehouseNo == 2) {
        state.warehouseTwo = action.payload.warehouse;
      }
    },
    setFromStockStatus: (state, action) => {
      state.from_stock_status = action.payload.value;
    },
    setToStockStatus: (state, action) => {
      state.to_stock_status = action.payload.value;
    },
    setDeliveryDate: (state, action) => {
      state.deliveryDate = action.payload.deliveryDate;
    },
  },
});
